import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LinkService {
  public static OpenExternalLink(url: string, newTab: boolean = true): void {
    if (newTab) {
      window.open(url, '_blank');
    } else {
      window.location.href  = url;
    }
  }
}
